<template>
  <div class="book-a-meeting">
    <slot name="tool-tip-bam" />
    <div class="book-a-meeting-btn" :class="{ navigationOpened: isNavigationOpened }">
      <transition name="slide" />
      <DeckControlsContainer class="icon-container" :style="{ transition: `all ${transitionDuration}s` }">
        <DeckControlButton class="flex items-end p-3.5" @click="onButtonClicked">
          <CalendarIcon class="w-5 h-5 mr-2" />
          <span>Book a Meeting</span>
        </DeckControlButton>
      </DeckControlsContainer>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Deck } from '@/entities/deck'
import { CalendarIcon } from '@heroicons/vue/24/outline'
import type { DeepReadonly } from 'vue'

const props = defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<Deck>>,
    required: true,
  },
  isNavigationOpened: {
    type: Boolean,
    default: true,
  },
  transitionDuration: {
    type: Number,
    default: 0.5,
  },
})

const { $analytics } = useNuxtApp()

onMounted(() => {
  $analytics.track('showedButtonBookAMeeting', { location: 'deck-content' })
})

function onButtonClicked() {
  $analytics.track('bookAMeetingClicked')

  window.open(window.location.origin + `/meetings/book/${props.deck.request_setting_id}`)
}
</script>
